import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';
import { IconType } from 'react-icons';

interface SafeIconProps extends React.SVGAttributes<SVGElement> {
  icon?: IconType | null;
  name?: string;
  className?: string;
  [key: string]: any;
}

const SafeIcon: React.FC<SafeIconProps> = ({ icon: IconComponent, name, className = "", ...props }) => {
  // 優先使用傳入的組件，其次嘗試從 FiIcons 找名稱
  const FinalIcon = IconComponent || (name ? (FiIcons as any)[`Fi${name}`] : null);

  if (!FinalIcon) {
    return <FiAlertTriangle className={`text-red-400 ${className}`} {...props} />;
  }

  return <FinalIcon className={className} {...props} />;
};

export default SafeIcon;